import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const HeaderRlt1 = () => {
  return <header className="bg-white" data-id="element-7557">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-7558"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-7559">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-7560">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-7561">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-7562">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex justify-start mb-3" data-id="element-7563">
          <div className="text-xs text-gray-400 font-sans" data-id="element-7564">Advertorial 1</div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-7565">
          <div className="text-left" data-id="element-7566">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-7567">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-7568">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-7569">
        <div className="max-w-4xl mx-auto" data-id="element-7570">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-7571">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-7572">
            PhD Exercise Physiologist Investigates: Is Red Light Therapy for Fat
            Loss a Scam—Or Are Most Devices Just Built Wrong?
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-7573">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-7574">
              <img src="https://cdn.magicpatterns.com/uploads/gehR2J4CXmU1bRL6g8riDo/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell" className="w-full h-full object-cover" data-id="element-7575" />
            </div>
            <div className="flex-1" data-id="element-7576">
              <div className="flex items-center" data-id="element-7577">
                <div className="font-medium text-gray-900 text-lg" data-id="element-7578">
                  By Dr. Sarah Mitchell, PhD
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-7579">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-7580" />
                  <span className="text-xs ml-1 font-medium" data-id="element-7581">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-7582">
                Exercise Physiology, University of Texas
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-7583">
                <div className="flex items-center mr-4" data-id="element-7584">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-7585" />
                  <span data-id="element-7586">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-7587">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-7588" />
                  <span data-id="element-7589">47,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-7590">
            An Independent Analysis by Dr. Sarah Mitchell, PhD | Exercise
            Physiology. Updated: January 2026
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-7591">
            <div className="mb-1 flex items-center" data-id="element-7592">
              <span className="font-medium mr-2" data-id="element-7593">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-7594">
              <span className="font-medium mr-2" data-id="element-7595">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-7596">
        <div className="max-w-4xl mx-auto" data-id="element-7597">
          <div className="sm:flex items-center" data-id="element-7598">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-7599">
              <img src="https://cdn.magicpatterns.com/uploads/gehR2J4CXmU1bRL6g8riDo/Nv5hjWTSn23lO9R9rbGUj.png" alt="Dr. Sarah Mitchell in research lab" className="w-full rounded-lg shadow-md" data-id="element-7600" />
            </div>
            <div className="sm:w-2/3" data-id="element-7601">
              <p className="text-sm text-gray-700 mb-2" data-id="element-7602">
                <span className="font-bold" data-id="element-7603">Dr. Sarah Mitchell, PhD</span> has
                spent 25 years in exercise physiology research and clinical
                practice. With a doctorate from the University of Texas, she has
                published extensively on metabolic adaptation and body
                composition.
              </p>
              <p className="text-sm text-gray-700" data-id="element-7604">
                Her investigative work focuses on separating evidence-based
                treatments from marketing hype, helping patients make informed
                health decisions based on scientific testing rather than trends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderRlt1;